import React from 'react';
import './Toast.css';
import { useT } from '../i18n';

function Toast({ message, type = 'error', onClose }) {
  const { t } = useT();
  if (!message) return null;
  return (
    <div className={`toast toast-${type}`}>
      <span>{message}</span>
      <button onClick={onClose}>{t('close')}</button>
    </div>
  );
}

export default Toast;
